import { init as initSentry } from '@/utils/asyncSentry'

import { SENTRY } from './config'
import { sagas as rootSaga, configureStore, initialState } from './main'
import { initLocation } from './tracking'

initSentry({
  ...SENTRY,
  release: process.env.SOURCE_VERSION
})

export default ({ history, preparedState = {} }) => {
  const sourceJobId = preparedState?.selected?.job?.sourceJobId
  initLocation(history, sourceJobId)

  const store = configureStore(history, initialState(preparedState))

  store.runSaga(rootSaga)

  return { history, store }
}
